import React from "react";
import { Divider, Container, Header, Image } from "semantic-ui-react";
const imageList = [
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/shipmntapp%2F1.jpg?alt=media&token=9313d11b-0a05-43ad-898e-665fb33738b0",
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/shipmntapp%2F2.jpg?alt=media&token=dec6fb26-c9a2-4abe-8937-2cba5f60e3e7",
  "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/shipmntapp%2F3.jpg?alt=media&token=6dec1fcf-113a-479a-8603-a47760fe2d4b"
];
export const shipmnt = () => {
  return (
    <Container>
      <Divider hidden />
      <Header as="h1">
        <Header.Content>Shipment SaaS product</Header.Content>
        <Header.Subheader>
          <p>A platform to power Operation, Sales and Accounting</p>
          <p>Credit : Design</p>
          <small>*Images shown here are purposely skewed due to NDA.</small>
        </Header.Subheader>
      </Header>
      <Divider />
      <Image.Group>
        {imageList.map((url, i) => {
          return <Image key={i} src={url} rounded />;
        })}
      </Image.Group>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/Projects/shipmnt.js